'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = persist;

var _constants = require('./constants');

/**
 * Persist a callback function so it can be called multiple times
 */
function persist(func) {
  var listeners = [];

  var disposed = false;

  return {
    type: _constants.TYPE_PERSISTED_FUNCTION,
    apply: function apply(that, args) {
      if (disposed) {
        throw new Error(_constants.MESSAGE_DISPOSED_ERROR);
      }

      return func.apply(that, args);
    },
    dispose: function dispose() {
      listeners.forEach(function (listener) {
        return listener();
      });
      disposed = true;
    },
    on: function on(name, cb) {
      if (name === 'dispose') {
        listeners.push(cb);
      }
    },

    get disposed() {
      return disposed;
    }
  };
}
//# sourceMappingURL=persist.js.map